export default {
  uri: 'http://localhost:4443/api/',
  version: '0.0.1',
}
